import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { AddHeader } from "../../components/AddHeader";
import { EditGroup } from "../../components/AdminLayout/EditGroup";

export const UpdateGroup = () => {
  const { t } = useTranslation();

  return (
    <>
      <div id="adminRoot" className="group-form-theme">
        <AddHeader title={t("editgroup")} />
        <EditGroup />
      </div>
    </>
  );
};
